import lang from '@/lang'
import { getCustomAmountHeaderTemplate } from '@/modules/_helpers/getCustomAmountHeaderTemplate'
import { getAssignmentState } from '@/modules/banking/_helpers/assignmentState'
import ListColumnModel from '@/modules/base/model/list-column-model'
import { formatCurrency } from '@/modules/_helpers/formatCurrency'
import { formatIbanGroups } from '@/modules/base/components/inputs/iban-input/iban-input'

export default class BankingListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)

    this.displayed = data.displayed
    this.hide = data.hide || false
    this.setColumnSpecificProperties()
  }

  setColumnSpecificProperties() {
    switch (this.name) {
      case 'bic':
        this.sortable = false
        break
      case 'recipient':
        this.filter = 'agTextColumnFilter'
        this.subtitle = lang.booking.usage
        this.cellRenderer = 'recipentCellRenderer'
        this.comparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
          return valueA?.localeCompare(valueB)
        }
        break
      case 'bankAccountName':
        this.sortable = false
        this.filter = true
        this.comparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
          return valueA.localeCompare(valueB)
        }
        break
      case 'state':
        this.cellRenderer = 'stateCellRenderer'
        this.sortable = false
        this.filter = true
        this.alignment = 'center'
        this.comparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
          return valueA.localeCompare(valueB)
        }
        this.filterParams = {
          valueFormatter: (param) => {
            return getAssignmentState(param.value)
          },
        }
        break
      case 'endOfDayBalance':
        this.filter = 'agNumberColumnFilter'
        this.cellRenderer = 'endOfDayCellRenderer'
        this.filterParams = {
          inRangeInclusive: true,
        }
        this.getQuickFilterText = (params) => {
          return formatCurrency(params.value)
        }
        break
      case 'amount':
        this.setCurrencyType()
        this.headerComponentParams = { template: getCustomAmountHeaderTemplate() } // to make it right-bound
        this.cellRenderer = 'amountCellRenderer'
        break
      case 'date':
      case 'valueDate':
        this.setDateType()
        break
      case 'iban': {
        this.valueFormatter = (params) => {
          return formatIbanGroups(params.value)
        }
        break
      }
      default:
        this.sortable = true
        break
    }
  }
}
